'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');

module.exports = assign({}, ServiceClientBase.prototype, {

    /**
     * @param params
     * @param {string} params.lang language (en, fr, etc..)
     * @param {string} params.cntry country
     * @param {object[]} params.favorites array of favorite objects.
     * @param {string} params.favorites[].id restaurant id
     * @param {boolean} params.favorites[].defaultFlag set restaurant as default restaurant
     * @param {string} params.token user's auth token
     * @param {string} params.deviceId user's unique device id
     * @returns {Bluebird Promise}
     */
    save: function save(params) {
        var qs = this.pullQueryStringParams(params); //{lang: 'en', cntry: 'US', sourceCode: 'UNIFIED', version: '1.0.1'};
        var favoriteData = JSON.stringify({
            token: params.token,
            deviceId: params.deviceId,
            locations: [{ id: params.id, defaultFlag: params.isDefault }]
        });

        return this.postApiRequest(this.getUrl().favoriteLocationsSave, qs, favoriteData);
    },
    /**
     * @param paramss
     * @param {string} params.token user's token
     * @param {string} params.deviceId user's device id
     * @param {object} params.location
     * @param {string} params.location.address optional address
     * @param {string} params.location.lat optional lat
     * @param {string} params.location.lng optional lng
     * @returns {Bluebird Promise}
     */
    get: function get(params) {
        var qs = this.pullQueryStringParams(params); //{lang: 'en', cntry: 'US', sourceCode: 'UNIFIED', version: '1.0.1'};
        var data = {
            token: params.token,
            deviceId: params.deviceId
        };
        if (params.location) {
            if (params.location.address) {
                data.address = params.location.address;
            }
            if (params.location.lat) {
                data.lat = params.location.lat;
                data.lng = params.location.lng;
            }
        }
        var favoriteData = JSON.stringify(data);
        return this.postApiRequest(this.getUrl().favoriteLocationsGet, qs, favoriteData);
    },
    /**
     *
     * @param params
     * @param params.token users token
     * @param params.deviceId user's device id
     * @param params.id restaurant id to delete
     * @returns {*}
     */
    delete: function _delete(params) {
        var qs = this.pullQueryStringParams(params); //{lang: 'en', cntry: 'US', sourceCode: 'UNIFIED', version: '1.0.1'};
        var data = {
            token: params.token,
            deviceId: params.deviceId,
            id: params.id
        };

        var favoriteData = JSON.stringify(data);
        return this.postApiRequest(this.getUrl().favoriteLocationsDelete, qs, favoriteData);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/favoriteLocationServiceClient.js
// module id = 839
// module chunks = 0